<template>
	<div v-show="show_tan" class="pre_step">
		<span class="pre_step_bg" @click="closeshow"></span>
		<div class="pre_step_conten">
			<span class="pre_step_close">
				<img src="../../assets/image/shan1.png" @click="closeshow" />
			</span>
			<div class="pre_upload">
				<div class="pre_leve_one" v-loading="element_loading" element-loading-text="拼命加载中......"
					element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
					<h1>{{title}}&nbsp;<span class="red">单号:{{sheet_no}}</span></h1>

				</div>
				<div class="pre_leve_two">
					<!-- 这里放相关内容-->
					<!-- <div class="block">
            <el-timeline>
              <el-timeline-item v-for="(item,index) in list" :key="index" :timestamp="item.sys_date+' '+item.title"
                placement="top">
                <button class="step_look_btn" v-show="!item.show_me" @click="fun_show_me(item)">详情</button>
                <el-card :id="'step_'+item.id" class="my_step" >
                  <h4>{{item.title}}</h4>
                  <div v-html="item.note"></div>
                  <div class="step_btn">
                    <button @click="fun_close_me(item)">关闭</button>
                  </div>
                </el-card>
              </el-timeline-item>
            </el-timeline>
          </div> -->

					<ul class="my_step">
						<li v-for="(item,index) in list" :key="index">
							<div class="step_title">
								<h5>{{item.sys_date}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.u_name}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.title}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.keyword}}
								</h5>
								<button class="step_look_btn" v-show="!item.show_me"
									@click="fun_show_me(item)">详情</button>
							</div>
							<div :id="'step_'+item.id" class="step_card">
								<h4>{{item.title}}</h4>
								<div v-html="item.note"></div>
								<!-- <p>{{item.u_name}}&nbsp;&nbsp;&nbsp;&nbsp;{{item.flag}}</p> -->
								<div class="step_btn">
									<button @click="fun_close_me(item)">关闭</button>
								</div>
							</div>
							<div v-show="item.jiantou" class="step_jiantou">
								<i class="iconfont icon-xiangxiajiantou"></i>
							</div>

						</li>
					</ul>


				</div>

				<!-- 弹出向导层 end-->
			</div>
		</div>

	</div>

</template>

<script>
	/*
名称：通用基础模板2.0
日期：2021-05-24
作者：hj
目标：
方法 传入单号
返回 改单号的相关业务的审核流程

*/

	import api from '@/utils/type.js';
	import {
		Method_EasySelect,
		Method_Common
	} from '@/utils/loadhttpdata.js';

	import {
		ReplaceAll,
		JsonCheck,
		ChangeSpecial,
	} from '@/utils/method.js';

	export default {
		name: "pre_base_tan_step",
		components: {
			"pre-table": () => import("./pre_table_nokey2.vue")
		},
		data() {
			return {
				element_loading: false,
				show_tan: false,

				title: '',
				sheet_no: '',
				sel_action: '',

				parm: [], //参数结构
				parm_th: [], //标题

				list: [],

			};
		},
		props: {
			pre_show_tan: {
				type: String,
				default: ''
			},
			pre_data: {
				type: String,
				default: ''
			}
		},
		watch: {
			pre_show_tan(val) {
				if (Number(val) > 0) {
					this.show_tan = true;
				} else {
					this.show_tan = false;
				}
				this.change_show();
			}
		},
		mounted: function() {
			if (this.pre_data != '') {
				let that = this;
				this.$nextTick(function() {
					this.load_data();
				});
			}
		},
		methods: {
			newline: function(str) {
				// str = str.replace(/\"/g, "<br/>");
				// str = str.replace(/\r\n/g, "<br/>");
				// str = str.replace(" ", "&nbsp;&nbsp;&nbsp;&nbsp;");
				// console.log(str);
				let arr = [{
						"key": "\r\n",
						"val": "<br/>"
					},
					{
						"key": "\r",
						"val": "<br/>"
					},
					{
						"key": "\n",
						"val": "<br/>"
					},
					{
						"key": "\r\n",
						"val": "<br/>"
					}
				];
				let temp = '',
					a = '';
				temp = String(str);
				temp = ChangeSpecial(temp);
				if (temp) {
					// console.log(temp);
					for (let i = 0; i < arr.length; i++) {
						if (temp.indexOf(arr[i].key) >= 0) {
							let t = temp.split(arr[i].key);
							temp = t.join('<br/>');
						}
					}
					// console.log(temp);
					a = temp.split("<br/>");
				}

				// console.log(a);

				let b1 = '',
					b2 = '',
					b = '';
				if (a[0].indexOf(':') >= 0) {
					for (let i = 0; i < a.length; i++) {
						b1 = a[i].substr(0, a[i].indexOf(':'));
						b2 = a[i].substr(a[i].indexOf(":") + 1, a[i].length);
						// console.log(b1);
						// console.log(b2);
						b2 = b2.replace(/\r/g, "<br/>");
						// console.log(b2);
						b = b + "<div><label class='step_left'>" + b1 + "</label><span class='step_mid'>:</span>" +
							"<span class='step_right'>" + b2 +
							"</span></div>"
					}
				}
				if (a[0].indexOf('=') >= 0) {

					for (let i = 0; i < a.length; i++) {
						b1 = a[i].substr(0, a[i].indexOf('='));
						b2 = a[i].substr(a[i].indexOf("=") + 1, a[i].length);
						// console.log(b1);
						// console.log(b2);
						b2 = b2.replace(/\r/g, "<br/>");
						// console.log(b2);
						b = b + "<div><label class='step_left'>" + b1 + "</label><span class='step_mid'>:</span>" +
							"<span class='step_right'>" + b2 +
							"</span></div>"
					}
				}

				return b;
			},
			change_show: function() {
				// console.log('弹窗。。。。。');
				if (this.show_tan) {
					var Hg = $(document).height();
					// 设置背景高度
					$(".pre_step_bg").height(Hg);
					// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
					$(".pre_step_bg").fadeIn("3000");
					$(".pre_step_conten").fadeIn("3000");
					this.load_data(); //加载相关内容
				} else {
					this.closeshow();
				}
			},
			closeshow: function() {
				$(".pre_step_bg").fadeOut("3000");
				$(".pre_step_conten").fadeOut("3000");
				this.show_tan = false;
				this.$emit('base2tan-event', 'father');
			},
			load_data: function() {
				// console.log(this.pre_data);
				let r = JSON.parse(this.pre_data);
				// console.log(r);
				let that = this;
				this.$nextTick(function() {
					that.title = r.title;
					that.sheet_no = r.sheet_no;
					that.sel_action = r.sel_action;
					that.refresh_data();
				});
			},
			refresh_data: function() {
				this.list = [];
				this.$post(
					api.http_method, Method_EasySelect('data_' + this.sel_action, this.sheet_no)
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					// console.log(res);
					if (Number.parseInt(res.data.status) == 1) {
						var res = res.data.data;

						console.log(res);

						for (let i = 0; i < res.length; i++) {
							var o = {};
							o.id = res[i].id;
							o.title = res[i].title;
							o.keyword = res[i].keyword;
							o.note = this.newline(res[i].note);
							o.flag = res[i].flag;
							o.u_name = res[i].u_name;
							o.sys_date = res[i].sys_date;
							o.show_me = false;
							o.jiantou = true;

							if ((i + 1) == res.length) {
								o.jiantou = false;
							}

							this.list.push(o);
						}

						// console.log(this.list);

					} else {
						this.$message({
							message: '没有查询到数据',
							type: 'success'
						});
					}

				});
			},
			fun_show_me: function(item) {
				// console.log(item);
				item.show_me = true;
				// item.show_me = item.show_me ? false : true;
				// window.location.hash = "#step_"+item.id; //太快了，效果不好

				let tid = "#step_" + item.id

				$(tid).slideDown("slow");

				$('body,html').animate({
						scrollTop: $(tid).offset().bottom
					},
					500
				);

			},
			fun_close_me: function(item) {

				let tid = "#step_" + item.id

				$(tid).slideUp("slow");

				setTimeout(function() {
					item.show_me = false;
				}, 500);

				// $('body,html').animate({
				//     scrollTop: $(tid).offset().top
				//   },
				//   500
				// );
			}





		}
	};
</script>


<style scoped>
	.pre_step {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
	}

	.pre_step_bg {
		width: 100%;
		background: #000000;
		opacity: 0.5;
		position: fixed;
		top: 0;
		left: 0;
		height: 1340px;
		display: none;
		z-index: 3;
	}



	.pre_step_conten {
		position: fixed;
		width: 40%;
		height: auto;
		left: 30%;
		top: 8%;
		/* background: #faf5f5; */
		background-color: azure;
		border-radius: 5px;
		max-height: 80%;
		z-index: 3;
		overflow-y: auto;
		overflow-x: auto;

	}

	.pre_step_close {
		position: absolute !important;
		right: 1px !important;
		top: -5px !important;
		font-size: 30px !important;
		color: #b4b4b4;
		cursor: pointer;
		font-weight: normal;
	}
</style>